<template>
    <div class="body">
        <el-card>
            <el-form ref="form" :model="form" label-width="80px" @submit.native.prevent class="operationControl">
                <el-row>
                    <el-col :span="6" class="pr20">
                        <el-form-item label="课程名称" prop="trainingName">
                            <el-input v-model="form.trainingName" @keyup.enter.native="search" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="pr20">
                        <el-form-item label="培训类型" prop="trainingCategoryName">
                            <el-input clearable @focus="showSelectTreeCategoryVisible" ref="trainingCategoryInput" @clear="trainingCategoryNameClear" :disabled="$route.query.type == 'check'" v-model="form.trainingCategoryName" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <!--          <el-col :span="6" class="pr20">-->
                    <!--            <el-form-item label="状态" prop="isShelf">-->
                    <!--              <el-select v-model="form.isShelf" clearable placeholder="状态">-->
                    <!--                <el-option :key="true" label="上架" :value="true"></el-option>-->
                    <!--                <el-option :key="false" label="下架" :value="false"></el-option>-->
                    <!--              </el-select>-->
                    <!--            </el-form-item>-->
                    <!--          </el-col>-->
                    <el-col :span="6" class="pr20">
                        <el-form-item label="课程目录" prop="directoryId">
                            <selectTree
                                :props="{
                                    value: 'id', // ID字段名
                                    label: 'directoryName', // 显示名称
                                    children: 'directoryList', // 子级字段名
                                }"
                                :options="catalogList"
                                :value="form.directoryId"
                                :disabled="$route.query.type == 'check'"
                                @getValue="selectTreeChange"
                                clearable
                            ></selectTree>
                        </el-form-item>
                    </el-col>
                    <el-button type="primary" @click="search">搜索</el-button>
                    <el-button @click="resetForm('form')">重置</el-button>
                    <el-button @click="$router.push('/mall/examination/course/addCourse?type=edit')" type="primary" icon="el-icon-plus" class="mb20">添加课程</el-button>
                </el-row>
            </el-form>

            <selectTrainingCategory ref="selectTrainingCategory" @submit="selectTrainingCategorySubmitHandle"></selectTrainingCategory>

            <el-table :data="programList" style="width: 100%" @filter-change="handleFilter" v-loading="tableLoading" element-loading-text="拼命加载中" height="640">
                <el-table-column type="index" width="60" label="序号"></el-table-column>
                <el-table-column prop="trainingName" width="260" label="课程名称" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column
                    label="状态"
                    prop="shelf"
                    :filters="[
                        { text: '上架', value: true },
                        { text: '下架', value: false },
                    ]"
                    column-key="shelf"
                    width="120"
                    v-if="isOperating()"
                >
                    <template slot-scope="scope">
                        <!-- 0未下达 1进行中 2已下达 -->
                        <el-tag type="danger" v-if="!scope.row.shelf">已下架</el-tag>
                        <el-tag type="success" v-if="scope.row.shelf">已上架</el-tag>
                        <!--            <span >已下架</span>-->
                        <!--            <span v-if="scope.row.shelf">已上架</span>-->
                    </template>
                </el-table-column>
                <el-table-column width="200" label="培训类型" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="scope.row.trainingLevelName" v-html="scope.row.trainingLevelName"></span>
                        <span v-else>
                            --
                        </span>
                    </template>
                </el-table-column>
                <el-table-column width="200" label="行业类型" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span v-if="scope.row.trainingIndustryName" v-html="scope.row.trainingIndustryName"></span>
                        <span v-else>
                            --
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="createdTime" label="创建时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="$router.push('/mall/examination/course/detailCourse?type=check&id=' + scope.row.id)">详情</el-button>
                        <el-button size="mini" type="text" @click="$router.push('/mall/examination/course/updateCourse?type=edit&id=' + scope.row.id)">编辑</el-button>
<!--                         <el-button size="mini" type="text" @click="delProgram(scope.row.id)">删除</el-button>-->
                        <!--            <el-button-->
                        <!--              size="mini"-->
                        <!--              type="text"-->
                        <!--              v-if="isOperating()"-->
                        <!--              @click="showImportDrawer(scope.row.id)"-->
                        <!--            >导入-->
                        <!--            </el-button>-->
                        <el-button size="mini" type="text" v-if="!scope.row.shelf && isOperating()" @click="changeShelf(scope.row, true)">上架</el-button>
                        <el-button size="mini" type="text" v-if="scope.row.shelf && isOperating()" @click="changeShelf(scope.row, false)">下架</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination v-if="!tableLoading" background style="margin-top:20px; float:right;" @size-change="sizeChange" :current-page="page" @current-change="pageChange" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </el-card>
        <courseImport ref="courseImport"></courseImport>
    </div>
</template>

<script>
import API from "@/api/mall/training.js";
import exam from "@/api/mall/exam.js";
import courseImport from "@/pages/mall/course/courseImport";
import selectTree from "@/components/common/selectTree";
import selectTrainingCategory from "@/components/training/selectTrainingCategory";

export default {
    components: { selectTree, selectTrainingCategory, courseImport },
    data() {
        return {
            tableLoading: false,
            selectTreeCategoryVisible: false,
            form: {
                trainingName: "", //培训内容
                principalName: undefined, //负责人名称
                trainingContent: undefined, //培训内容
                startCreatedTime: undefined, //制定开始时间
                endCreatedTime: undefined, //制定结束时间
                issuedStatus: undefined, //下发状态
                startIssuedTime: undefined, //下发开始时间
                endIssuedTime: undefined, //下发结束时间
                createdTime: [],
                issuedTime: [],
                shelf: undefined, //上下架状态
                directoryId: undefined,

                // training
                trainingLevelName: undefined,
                trainingIndustryName: undefined,
                trainingPostName: undefined,
                trainingTypeName: undefined,

                trainingCategoryName: undefined,
            },
            programList: [],
            page: 1,
            pageSize: 10,
            total: 0, // 总条数
        };
    },
  // destroyed(){
  //   localStorage.removeItem("from");
  // },
    mounted() {

      let  froms=localStorage.getItem('from')
      console.log(froms)
      console.log(froms !="null")
      if(froms  !="null"){
        this.form=JSON.parse(froms)
        console.log( this.form)
      }
      let  pageObjStr = localStorage.getItem('pageObj')
      if (pageObjStr) {
        let pageObj =JSON.parse(pageObjStr);
        this.pageSize  = pageObj.pageSize;
        this.page  = pageObj.page;
      } else {
        this.page = 1;
      }
      this.$nextTick(() => {
        this.getProgramList();
        this.getCatalogList();
      }); 
    },
    methods: {
        sizeChange(e) {
            this.pageSize = e;
            this.getProgramList();
        },
        pageChange(e) {
            this.page = e;

            this.getProgramList();
        },

        trainingCategoryNameClear() {
            this.form.trainingLevelName = undefined;
            this.form.trainingIndustryName = undefined;
            this.form.trainingPostName = undefined;
            this.form.trainingTypeName = undefined;
        },
        search() {
            this.page = 1;
            this.getProgramList();
        },
        getProgramList() {

            let p = {
                ...this.form,
                // enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId,
            };
            p.page = this.page;
            p.pageSize = this.pageSize;

            localStorage.setItem("from",JSON.stringify(this.form))
            let pageObj = {
              page: p.page,
              pageSize: p.pageSize
            }
            localStorage.setItem("pageObj",JSON.stringify(pageObj));

            delete p.trainingCategoryName;

            if (p.createdTime.length > 0) {
                p.startCreatedTime = p.createdTime[0];
                p.endCreatedTime = p.createdTime[1];
            }

            if (p.issuedTime.length > 0) {
                p.startIssuedTime = p.issuedTime[0];
                p.endIssuedTime = p.issuedTime[1];
            }
            delete p.createdTime;
            delete p.issuedTime;

            this.tableLoading = true;
            API.getProgramList(p).then((res) => {
                this.programList = res.data.records;
                this.total = res.data.total;
                this.tableLoading = false;
            });
        },
        handleFilter(value) {
            if (value.shelf && value.shelf.length == 1) {
                this.form.isShelf = value.shelf[0];
            } else {
                this.form.isShelf = undefined;
            }
            this.search();
        },
        selectTrainingCategorySubmitHandle(data) {
            this.form.trainingLevelName = data.trainingLevelName;
            this.form.trainingIndustryName = data.trainingIndustryName;
            this.form.trainingPostName = data.trainingPostName;
            this.form.trainingTypeName = data.trainingTypeName;
            this.form.trainingCategoryName = data.trainingCategoryName;
        },
        showSelectTreeCategoryVisible() {
            this.$refs.trainingCategoryInput.blur();
            this.$refs.selectTrainingCategory.showDialog();
        },
        onSubmit() {
            console.log("submit!");
        },
        handleClick(row) {
            console.log(row);
        },
        //重置表单
        resetForm(formName) {
            this.trainingCategoryNameClear();
            this.$refs[formName].resetFields();
            this.search();
        },
        delProgram(programId) {
            this.$confirm("此操作将删除该计划, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                API.delProgram({ programId }).then((res) => {
                    if (res.code == 0) {
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        });
                        this.getProgramList();
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message,
                        });
                    }
                });
            });
        },
        showImportDrawer(trainingProgramId) {
            this.$refs.courseImport.showImportDrawer(trainingProgramId);
        },
        /**
         * 变更上下架状态
         * @param row
         * @param isShelf
         */
        changeShelf(row, isShelf) {
            let params = {
                id: row.id,
                isShelf: isShelf,
            };
            API.changeShelf(params).then((res) => {
                if (res.code == 0) {
                    if (isShelf) {
                        this.$message.success("已上架");
                    } else {
                        this.$message.success("已下架");
                    }
                    this.getProgramList();
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        getCatalogList() {
            exam.getCatalogList({
                type: 4,
                // enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
            }).then((res) => {
                this.catalogList = res.data;
            });
        },
        selectTreeChange(v) {
            this.form.directoryId = v.id;
        },
        /**
         * 判断是否是运营人员
         */
        isOperating() {
            let userInfo = JSON.parse(localStorage.getItem("userinfo"));
            return userInfo.isOperating;
        },
    },
};
</script>

<style scoped>
.form {
    position: relative;
}

.searchBut {
    position: absolute;
    right: 0;
    top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/mall/course/courseManagement.vue